import React from 'react';
import { withStyles } from "@material-ui/core/styles";
import { Checkbox, Slider } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import "./disabled.css";
import { ReactComponent as Lock } from '../asset/lock.svg';
import "../asset/lock.svg";

const styles = theme => ({

    InputFamily: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 20,
    },
    haiguushaBox: {
        flex: 3,
        textAlign: 'left',
        height: '60px'
    },
    familyTitle: {
        color: "#006699",
        //color: "#ad0021",
        //color: "#ee6e39",
        fontWeight: 'bold'
    },
    childBox: {
        flex: 6,
        alignItems: 'stretch',
        height: '50px'
    },
});

const DisabledFamily = (props) => {
    // console.log('props:', props);
    const { classes } = props;
    return (
        <div style={{ position: "relative" }}>
            <div className="disabled"></div>
            <div className={classes.InputFamily}>
                <Lock className="lock" onClick={()=>alert("アップグレードすると相続人の数を変更できます")} />
                <div className={classes.haiguushaBox}>
                    <span className={classes.familyTitle}>配偶者</span>は {props.haiguusha === 1 ? '有り' : '無し'}
                    <FormControlLabel
                    control={<Checkbox
                        checked={props.haiguusha === 1}
                        disabled
                    />}
                    label="有無"
                    labelPlacement="start"
                />
                </div>
                <div className={classes.childBox}>
                    <div style={{ textAlign: 'center', fontSize: '16px' }}><span className={classes.familyTitle}>子供の数</span>: {props.child} 人</div>
                    <Slider
                        value={props.child}
                        max={5}
                        min={1}
                        step={1}
                        marks={true}
                        color={"secondary"}
                        disabled
                    />
                </div>
            </div>
        </div>);
};

export default withStyles(styles)(DisabledFamily);